import React from "react";
import secureLocalStorage from "react-secure-storage";

export default function LeftMenu() {
  const pathname = window.location.pathname;
  const menuperm = JSON.parse(secureLocalStorage.getItem('menuperm'));
  //console.log('menu permission on left menu')
  //console.log(menuperm)

  function toggleMenu() {
    const element = window.document.querySelector(".wrapper")
    if (element) {
      element.classList.toggle('sidebar_minimize')
    }
  }

  return (
    <div className="sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <a href="/" className="logo">
            <img
              src="/assets/img/logo-amway-white.svg"
              alt="Amway logo"
              className="navbar-brand"
              height="20"
            />
          </a>
          <div className="nav-toggle">
            <button className="btn btn-toggle toggle-sidebar" onClick={toggleMenu.bind(this)}>
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            <li className="nav-section">
              <span className="sidebar-mini-icon">
                <i className="bi bi-three-dots"></i>
              </span>
              <h4 className="text-section">Menu</h4>
            </li>
            {
              menuperm?.map((mitem, index) => {
                let isShowMenu = mitem.roleid > 0
                if (isShowMenu) {
                  return (
                    <li key={index} className={pathname === mitem.pathname ? 'nav-item active' : 'nav-item'}>
                      <a href={mitem.pathname}>
                        <i className={mitem.mclass} style={{ "fontSize": "1.5em" }} title={mitem.title}></i>
                        <p>{mitem.title}</p>
                      </a>
                    </li>
                  )
                }
              })
            }
          </ul>
        </div>
      </div>
    </div>

  )
}